import { CourseCertify } from "../../Models/Course";
import { InterActive } from "../../utilities/ViewModelStructure";

export class CertifiesCardVM extends InterActive{
    private data?:CourseCertify 

    public get Data():CourseCertify|undefined{ return this.data }

    public setData(data:CourseCertify){
        this.loading(
            async()=>{
                this.data = data
                this.update()
            }
        )
    }
}